import { render, staticRenderFns } from "./import-relate-product.vue?vue&type=template&id=71b0c7f6&scoped=true&"
import script from "./import-relate-product.vue?vue&type=script&lang=js&"
export * from "./import-relate-product.vue?vue&type=script&lang=js&"
import style0 from "./import-relate-product.vue?vue&type=style&index=0&id=71b0c7f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b0c7f6",
  null
  
)

export default component.exports